import Modules from '@/model/modules';
import {RouteModule} from '@/types/route-type';
import InfoDetail from './info-detail/info-detail';
import InfoList from './info-list/info-list';

const Module: RouteModule = {
    module: Modules.INFO,
    pages: [
        {
            path: '/info',
            element: InfoList,
        },
        {
            path: '/info/:code',
            element: InfoDetail,
        },
    ],
};

export default Module;
